import enAuth from './locales/en/auth';
import enCommon from './locales/en/common';
import enDashboard from './locales/en/dashboard';
import enFeatures from './locales/en/features';
import enFooter from './locales/en/footer';
import enHome from './locales/en/home';
import enModals from './locales/en/modals';
import enNavbar from './locales/en/navbar';
import enPages from './locales/en/pages';
import enPetForm from './locales/en/petForm';
import enPetProfile from './locales/en/petProfile';
import enSharePage from './locales/en/sharePage';
import enSupport from './locales/en/support';
import enBlog from './locales/en/blog';

import zhAuth from './locales/zh/auth';
import zhCommon from './locales/zh/common';
import zhDashboard from './locales/zh/dashboard';
import zhFeatures from './locales/zh/features';
import zhFooter from './locales/zh/footer';
import zhHome from './locales/zh/home';
import zhModals from './locales/zh/modals';
import zhNavbar from './locales/zh/navbar';
import zhPages from './locales/zh/pages';
import zhPetForm from './locales/zh/petForm';
import zhPetProfile from './locales/zh/petProfile';
import zhSharePage from './locales/zh/sharePage';
import zhSupport from './locales/zh/support';
import zhBlog from './locales/zh/blog';

import jaAuth from './locales/ja/auth';
import jaCommon from './locales/ja/common';
import jaDashboard from './locales/ja/dashboard';
import jaFeatures from './locales/ja/features';
import jaFooter from './locales/ja/footer';
import jaHome from './locales/ja/home';
import jaModals from './locales/ja/modals';
import jaNavbar from './locales/ja/navbar';
import jaPages from './locales/ja/pages';
import jaPetForm from './locales/ja/petForm';
import jaPetProfile from './locales/ja/petProfile';
import jaSharePage from './locales/ja/sharePage';
import jaSupport from './locales/ja/support';
import jaBlog from './locales/ja/blog';

// 🔧 修正：直接導出完整的翻譯對象
const translations = {
  en: {
    auth: enAuth,
    common: enCommon,
    dashboard: enDashboard,
    features: enFeatures,
    footer: enFooter,
    home: enHome,
    modals: enModals,
    navbar: enNavbar,
    pages: enPages,
    petForm: enPetForm,
    petProfile: enPetProfile,
    sharePage: enSharePage,
    support: enSupport,
    blog: enBlog
  },
  zh: {
    auth: zhAuth,
    common: zhCommon,
    dashboard: zhDashboard,
    features: zhFeatures,
    footer: zhFooter,
    home: zhHome,
    modals: zhModals,
    navbar: zhNavbar,
    pages: zhPages,
    petForm: zhPetForm,
    petProfile: zhPetProfile,
    sharePage: zhSharePage,
    support: zhSupport,
    blog: zhBlog
  },
  ja: {
    auth: jaAuth,
    common: jaCommon,
    dashboard: jaDashboard,
    features: jaFeatures,
    footer: jaFooter,
    home: jaHome,
    modals: jaModals,
    navbar: jaNavbar,
    pages: jaPages,
    petForm: jaPetForm,
    petProfile: jaPetProfile,
    sharePage: jaSharePage,
    support: jaSupport,
    blog: jaBlog
  }
};

// 🔧 修正:默認導出翻譯對象（而不是函數）
export default translations;